"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestReducer = exports.requestMiddleware = undefined;

var _handler = require("./request/handler");

var _handler2 = _interopRequireDefault(_handler);

var _reducer = require("./request/reducer");

var _reducer2 = _interopRequireDefault(_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const requestMiddleware = config => {
  return ({
    dispatch,
    getState
  }) => next => action => {
    if (action.request) return new _handler2.default(dispatch, action, getState, next, config).send();
    return next(action);
  };
};

exports.requestMiddleware = requestMiddleware;
exports.requestReducer = _reducer2.default;